import emailjs from "@emailjs/browser";
import React, { useState } from "react";
import { FaPhoneAlt } from "react-icons/fa";
import { MdEmail } from "react-icons/md";
import { useContextHook } from "../../Context/ContextOPen";
import { Col, Container, Row } from "../../Tools/Grid-system";
import space from "../../images/earth-day-and-night-from-space-wallpaper-preview.jpg";
import MainButton from "../Buttons/MainButton";
import ContactIcons from "../ContactIcons/ContactIcons";
const ContactUs = () => {
  const { content, direction, setSuccessMessage } = useContextHook();

  const [formData, setFormData] = useState({
    user_name: "",
    user_email: "",
    project_idea: "",
    message: "",
  });
  const handleChangeInput = (event) => {
    const { name, value } = event.target;

    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));
  };
  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm("service_uv1x1ao", "template_ywaxgvi", formData, {
        publicKey: "9CggmX6qplByDSqNn",
      })
      .then(
        () => {
          setFormData({
            user_name: "",
            user_email: "",
            project_idea: "",
            message: "",
          });
          setSuccessMessage(content.SendSuccessful);
        },
        (error) => {
          setSuccessMessage(content.SendSuccessful);

          setFormData({
            user_name: "",
            user_email: "",
            project_idea: "",
            message: "",
          });
        }
      );
  };
  return (
    <div
      style={{ direction: direction }}
      className="py-1 relative max-md:ContactUsBg lg:h-[92.5dvh]"
    >
      <img src={space} alt="" className="absolute w-full h-full -z-10" />
      <div className="absolute w-full h-full contactUs -z-10" />
      <Container>
        <h1
          className={`text-5xl max-md:text-4xl md:text-center font-bold mb-2 logo first-letter:text-Main transition-all`}
        >
          {content.ContactUs}
        </h1>
        <Row className="max-md:flex-col-reverse">
          <Col md={6}>
            <form onSubmit={sendEmail}>
              <Row className="py-3 ">
                <Col col={12}>
                  <h3 className="mb-5 text-3xl max-md:text-2xl font-semibold logo transition-all">
                    {content.StartHere}
                  </h3>
                </Col>
                <Col md={6}>
                  <Input
                    onChange={handleChangeInput}
                    value={formData.user_name}
                    name="user_name"
                    placeholder={content.Name}
                  />
                </Col>
                <Col md={6}>
                  <Input
                    onChange={handleChangeInput}
                    value={formData.user_email}
                    name="user_email"
                    placeholder={content.EmailOrPhone}
                  />
                </Col>
                <Col>
                  <Input
                    onChange={handleChangeInput}
                    value={formData.project_idea}
                    name="project_idea"
                    placeholder={content.ProjectIdea}
                  />
                </Col>
                <Col>
                  <textarea
                    onChange={handleChangeInput}
                    value={formData.message}
                    name="message"
                    placeholder={content.OtherAddition}
                    className="w-full py-2 bg-transparent border border-Main rounded-xl px-3 h-[160px] outline-none contactShadow"
                  />
                </Col>
                <Col md={6}>
                  <MainButton
                    name={content.Send}
                    className=" w-full text-center"
                  />
                </Col>
              </Row>
            </form>
          </Col>
          <Col
            md={6}
            className="flex md:justify-center items-center  md:text-2xl "
          >
            <div className="space-y-5 text-xl max-xs:text-lg">
              <div className="flex gap-3 logo">
                <FaPhoneAlt className="text-Main logo" />
                <div>+963 968 339 368</div>
              </div>
              <div className="flex gap-3 logo">
                <FaPhoneAlt className="text-Main logo" />
                <div>+963 992 579 620</div>
              </div>
              <div className="flex gap-3 logo">
                <MdEmail className="text-Main logo" />
                <div>BrabusCodeCompany@gmail.com</div>
              </div>
              <ContactIcons index={4} />
            </div>
          </Col>
        </Row>
      </Container>
      <p className="text-center px-2">
        All Rights Reserved For Brabus Code company @{new Date().getFullYear()}
      </p>
    </div>
  );
};

export default ContactUs;
const Input = ({ placeholder, name, value, onChange }) => {
  return (
    <div>
      <input
        required
        onChange={onChange}
        value={value}
        name={name}
        placeholder={placeholder}
        className="w-full py-4 bg-transparent border border-Main rounded-xl my-1 outline-none contactShadow"
      />
    </div>
  );
};
